// components/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useSubscription } from "./SubscriptionContext";

const PrivateRoute = ({ children }) => {
  const { isSubscribed, loading } = useSubscription();

  console.log("Subscription check:", { isSubscribed, loading });

  if (loading) {
    return <div>Loading...</div>;
  }

  return isSubscribed ? children : <Navigate to="/pricing" />;
};

export default PrivateRoute;
